// extracted by mini-css-extract-plugin
export default {"ttl":"styles_ttl__E5jH0","txt":"styles_txt__SvHPd","btn":"styles_btn__08mD3","backBtn":"styles_backBtn__8E0AZ","success":"styles_success__rqInZ"};